const REDIRECT_URL = 'https://jiraaf.page.link/iJ7W';

export { REDIRECT_URL };
